import { Input, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { type FacilityWithDistance } from "../../data/schemas";
import { EarlyAccessFacilitiesList } from "./EarlyAccessFacilitiesList";
import { useEarlyAccessListView } from "./hooks/useEarlyAccessListView";

interface EarlyAccessListContainerProps {
  facilities: FacilityWithDistance[];
  workerLocation: { lat: number; lng: number } | undefined;
  onFacilitySelect: (facility: FacilityWithDistance) => void;
  isLoading?: boolean;
}

export function EarlyAccessListContainer(props: EarlyAccessListContainerProps) {
  const { facilities, workerLocation, onFacilitySelect, isLoading = false } = props;

  const { searchTerm, setSearchTerm, debouncedSearchTerm, nearMeGroup, allOtherGroup } =
    useEarlyAccessListView({
      facilities,
      workerLocation,
    });

  const totalCount = nearMeGroup.totalCount + allOtherGroup.totalCount;
  const isEmpty = totalCount === 0;

  return (
    <Stack
      sx={{
        height: "100%",
        gap: 3,
        display: "flex",
        flexDirection: "column",
        px: 6,
      }}
    >
      <Text
        semibold
        align="center"
        variant="body1"
        color={(theme) => theme.palette.text.secondary}
        sx={{ opacity: isLoading ? 0 : 1 }}
      >
        {totalCount} {totalCount === 1 ? "facility" : "facilities"} in area
      </Text>

      <Input
        fullWidth
        placeholder="Search facilities by name or address"
        iconType="search"
        size="medium"
        value={searchTerm}
        onChange={(event) => {
          setSearchTerm(event.target.value);
        }}
      />

      <Stack
        sx={(theme) => ({
          height: "100%",
          minHeight: theme.size?.bottomSheet.loading.minHeight,
          justifyContent: isLoading ? "center" : "flex-start",
        })}
      >
        <EarlyAccessFacilitiesList
          isLoading={isLoading}
          isEmpty={isEmpty}
          searchTerm={debouncedSearchTerm}
          nearMeGroup={nearMeGroup}
          allOtherGroup={allOtherGroup}
          onFacilitySelect={onFacilitySelect}
        />
      </Stack>
    </Stack>
  );
}
